import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { DireccioneModel, IDireccion } from "../../models/general/cliente.model";
import { IPaquetebas, ITiendas, ITransportadoras, PaquetebasModel } from "../../models/not/notificacion.model";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { CONTROL_APP_CONST } from "../../config/control-app.constant";
import {
  ISimpleTableConfig,
  SimpleTableConfig
} from "../../../control-core/shared/simple-table/simple-table.component";
import Swal from 'sweetalert2'
import * as cloneDeep from 'lodash/cloneDeep';

import { ITipoTable } from "../../models/general/tipo.model";
import { DANGER_NOTIFY, notify, WARING_NOTIFY } from "../../../control-core/util/notify.util";
import { Subscription } from "rxjs/Subscription";
import { AuthService } from "../../../control-core/services/auth.service";
import { SHAKE_ANIMATION, animation } from '../../../control-core/util/animation.util';
import { GeparametersService } from "../../../control-core/services/geparameters.service";
import { DireccionesUserComponent } from "../direcciones-user/direcciones-user.component";
import { NGXLogger } from "ngx-logger";
import { IUserC, UserCModel } from "../../../control-app/models/user.model";

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-crear-notificacion',
  templateUrl: 'crear-notificacion.component.html',
  styleUrls: ['crear-notificacion.component.css']
})
export class CrearNotificacionComponent implements OnInit {

  @ViewChild(DireccionesUserComponent) direccionesUserComponent: DireccionesUserComponent;

  @Output() onCreacion: EventEmitter<{ success: boolean, msg: string }> = new EventEmitter();

  msgChecBoxBodega = this._translate.instant('CHCK_BODEGA_LABEL');
  tiposNotificacion = [];
  _notificacionSel: string = '-1';
  paqueteEnBodega: boolean = false;
  checkBoxDestinatario: boolean = true;
  notifi_id: string = '';
  pickup_id: string = '';
  compraWebBox: string = '';
  limitVlrDeclarado: number = 0;
  limitVlrAsegurado: number = 0;
  minVlrDeclarado: number = 0;
  minVlrAsegurado: number = 0;

  
  userInfo: IUserC = new UserCModel();
  private _userInfo$Unsubscribe: Subscription = null;
  

  public files: File[] = [];
  public accept = 'image/png,image/jpeg,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf';
  public hasBaseDropZoneOver: boolean = false;
  public dataFormData: FormData;
  public objDireccionEdit: IDireccion;
  public newPaquete: IPaquetebas = new PaquetebasModel();
  public listaTransportadoras: Array<{ id: string, nombre: string }>;
  public listaTiendas: Array<{ id: string, nombre: string }>;
  public _YES_LABEL = this._translate.instant('YES_LABEL');
  public _NO_LABEL = this._translate.instant('NO_LABEL');
  public VLRDEC_WHR_INVALID_LABEL = "";
  public _objetEmmit: {
    success: boolean,
    msg: string
  };

  private confirmaNotif = this._translate.instant('CONFIRM_REG_NOTIF_LABEL');
  private confirmaDelete = this._translate.instant('CONFIRM_DEL_PAQUETE_LABEL');
  private _subGeparameters$: Subscription = null;

  blockSendNotBoton: boolean = false;
  bloqueaBoton: boolean = false;

  dataErrorNotificacion = {
    error: {
      tipoRecogida: false,
      ciudad: false,
      direccionEdit: false,
      zipEdit: false
    },
    text: {
      tipoRecogida: 'CAMPO_REQUIRED_LABEL',
      ciudad: 'CAMPO_REQUIRED_LABEL',
      direccionEdit: 'CAMPO_REQUIRED_LABEL',
      zipEdit: 'CAMPO_REQUIRED_LABEL'
    }
  };

  configTablaPaquetes: ISimpleTableConfig;

  tiposRecogida = [];
  _recogidaSel: string = '';

  rowId: number = 1;

  set declaradoPaquete(val: number) {
    this.newPaquete.valordeclarado = val;
    this.setNewValorAsegurado();
  }

  get declaradoPaquete() {
    return this.newPaquete.valordeclarado;
  }

  dataHelpPaquete = {
    tracking: 'TEXTO_AYUDA_TRACKING',
    peso: 'RUL_PESO_MIN1_MAX110',
    altopqt: '',
    anchopqt: '',
    largopqt: '',
    valorasegurado: '',
    url: '',
    cantidad: '',
    paqdesc: 'PQT_CONTENTE_LABEL'
  };

  dataErrorPaquetes = {
    error: {
      tracking: false,
      valordeclarado: false,
      peso: false,
      altopqt: false,
      anchopqt: false,
      largopqt: false,
      paqdesc: false,
      url: false,
      cantidad: false
    },
    text: {
      tracking: 'CAMPO_REQUIRED_LABEL',
      valordeclarado: '',
      peso: "PESO_ERR_MIN1_MAX110",
      altopqt: "CAMPO_REQUIRED_LABEL",
      anchopqt: "CAMPO_REQUIRED_LABEL",
      largopqt: "CAMPO_REQUIRED_LABEL",
      paqdesc: 'CAMPO_REQUIRED_LABEL',
      url: 'CAMPO_REQUIRED_LABEL',
      cantidad: 'ERR_CNTD_PQT_MAX6',
    }
  };

  set notificacionSel(val: string) {
    this._notificacionSel = val;
    this.setTipoNotificacion();
  }

  get notificacionSel(): string {
    return this._notificacionSel;
  }


  constructor(private _http: HttpClient,
              private _translate: TranslateService,
              private _parameters: GeparametersService,
              private _authService: AuthService,
              private _logger: NGXLogger) {
  }

  ngOnInit() {
    this._userInfo$Unsubscribe = this._authService.userInfo$
        .subscribe((iUserInfo: IUserC) => this.userInfo = iUserInfo);

    this._subGeparameters$ = this._parameters.state$.subscribe((estado) => {
      if (estado == 'ready') {
        this.limitVlrDeclarado = this._parameters.getNumval('CTRLBX_LIMIT_VLR_DECLARADO');
        this.limitVlrAsegurado = this._parameters.getNumval('CTRLBX_LIMIT_VLR_ASEGURADO');
        this.minVlrAsegurado = this._parameters.getNumval('CTRLBX_MIN_VLR_ASEGURADO');
        this.minVlrDeclarado = this._parameters.getNumval('CTRLBX_MIN_VLR_DECLARADO');
        this.VLRDEC_WHR_INVALID_LABEL = this._translate.instant('VLRDEC_WHR_INVALID_LABEL',
            {
              maximo_declarado: this.limitVlrDeclarado,
              minimo_declarado: this.minVlrDeclarado
            });
      }
    });

    this.objDireccionEdit = new DireccioneModel();
    this.listaTransportadoras = [];
    this.listaTiendas = [];
    this.setPaquete();
    this.getTransportadoras();
    this.getTiendas();
    this.getTipNotificacion();
    this.getTipRecogida();

    this.configTablaPaquetes = new SimpleTableConfig();

    this.configTablaPaquetes.optionColumns = [{
      label: 'DELETE_LABEL', action: (row) => {
        this.delPaquete(row);
      }
    }];
  }

  setPaquete() {

    this.newPaquete.tracking = '';
    this.newPaquete.valordeclarado = 0;
    this.newPaquete.valorasegurado = 0;
    this.newPaquete.peso = 0;
    this.newPaquete.altopqt = 0;
    this.newPaquete.anchopqt = 0;
    this.newPaquete.largopqt = 0;
    this.newPaquete.paqdesc = '';
    this.newPaquete.webtienda_id = null;
    this.newPaquete.webtransportadora_id = null;
    this.newPaquete.url = '';
    this.newPaquete.cantidad = 0;

    this.newPaquete.tienda = {
      nombre: '',
      id: null
    };

    this.newPaquete.transportadora = {
      id: null,
      nombre: ''
    };

    this.files.splice(0, 1);
  }

  addPaquete(file) {
    if (!this.checkPaquete()) {
      let mensaje = this._translate.instant("ERROR_FORMULARIO_PQT_LABEL");
      notify(mensaje, DANGER_NOTIFY);
      return false;
    }

    if (this.newPaquete.tienda.id != null) {
      this.newPaquete.webtienda_id = this.newPaquete.tienda.id;
    } 
    // else if (this.newPaquete.tienda.id == null) {
    //   this.newPaquete.webtienda_id = '???';
    //   console.log("in else if"+this._authService.loadUserInfo());
    // }

    if (this.newPaquete.transportadora.id != null) {
      this.newPaquete.webtransportadora_id = this.newPaquete.transportadora.id;
    }

    this.newPaquete.rowId = this.rowId++;

    let objPaquete = cloneDeep(this.newPaquete);

    if (this._notificacionSel == this.notifi_id) {
      objPaquete.adjunto = this.files[0];
    }

    this.configTablaPaquetes.data.push(objPaquete);
    this.setPaquete();
  }

  checkPaquete() {
    this.dataErrorPaquetes.error.tracking = false;
    this.dataErrorPaquetes.error.valordeclarado = false;
    this.dataErrorPaquetes.error.peso = false;
    this.dataErrorPaquetes.error.altopqt = false;
    this.dataErrorPaquetes.error.anchopqt = false;
    this.dataErrorPaquetes.error.largopqt = false;
    this.dataErrorPaquetes.error.paqdesc = false;

    let x = 0;

    if (this._notificacionSel == this.pickup_id || this._notificacionSel == this.notifi_id) {

      if (this._notificacionSel == this.notifi_id) {
        if (this.newPaquete.tracking == '') {
          this.dataErrorPaquetes.error.tracking = true;
          x++;
        }

        if (this.newPaquete.valordeclarado > this.limitVlrDeclarado || this.newPaquete.valordeclarado < this.minVlrDeclarado) {
          this.dataErrorPaquetes.text.valordeclarado = this.VLRDEC_WHR_INVALID_LABEL
          this.dataErrorPaquetes.error.valordeclarado = true;
          x++;
        }
      }

      if (this._notificacionSel == this.pickup_id) {
        if (this.newPaquete.valordeclarado < this.minVlrAsegurado) {
          this.dataErrorPaquetes.text.valordeclarado = "INGR_VALOR_LABEL";
          this.dataErrorPaquetes.error.valordeclarado = true;
          x++;
        }

        if (this.newPaquete.peso <= 0) {
          this.dataErrorPaquetes.error.peso = true;
          x++;
        }

        if (this.newPaquete.altopqt <= 0) {
          this.dataErrorPaquetes.error.altopqt = true;
          x++;
        }

        if (this.newPaquete.anchopqt <= 0) {
          this.dataErrorPaquetes.error.anchopqt = true;
          x++;
        }

        if (this.newPaquete.largopqt <= 0) {
          this.dataErrorPaquetes.error.largopqt = true;
          x++;
        }

        if (x == 0) {

          let limitUps = false;

          let max = Math.max(this.newPaquete.altopqt, this.newPaquete.anchopqt, this.newPaquete.largopqt);

          if (this.newPaquete.anchopqt == max) {
            limitUps = this.checkUps(this.newPaquete.anchopqt, this.newPaquete.largopqt, this.newPaquete.altopqt)
          } else if (this.newPaquete.largopqt == max) {
            limitUps = this.checkUps(this.newPaquete.largopqt, this.newPaquete.anchopqt, this.newPaquete.altopqt)
          } else {
            limitUps = this.checkUps(this.newPaquete.altopqt, this.newPaquete.anchopqt, this.newPaquete.largopqt)
          }

          if (limitUps) {
            let mensaje = this._translate.instant("ERROR_UPS_LIMIT_SUPERADO_LABEL");
            notify(mensaje, DANGER_NOTIFY);
            x++;
          }
        }
      }

      if (this._notificacionSel == this.notifi_id && this.files.length == 0) {
        let mensaje = this._translate.instant("ERROR_NO_FILE_LABEL");
        notify(mensaje, DANGER_NOTIFY);
        x++;
      }

      if (this.newPaquete.valorasegurado > this.newPaquete.valordeclarado) {
        let mensaje = this._translate.instant("ERROR_VLR_ASGR_VLR_DLRDO");
        notify(mensaje, DANGER_NOTIFY);
        x++;
      }

      if (this.newPaquete.paqdesc == '') {
        this.dataErrorPaquetes.error.paqdesc = true;
        x++;
      }
    }

    if (this._notificacionSel == this.compraWebBox) {
      if (this.newPaquete.url == '') {
        this.dataErrorPaquetes.error.url = true;
        x++;
      }

      if (this.newPaquete.cantidad <= 0 || this.newPaquete.cantidad > 6) {
        this.dataErrorPaquetes.error.cantidad = true;
        x++;
      }
    }

    return (x == 0);
  }

  delPaquete(row) {
    this.bloqueaBoton = true;

    Swal({
      title: '',
      html: '<span style="font-size: 15px">' + this.confirmaDelete + '</span>',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: this._YES_LABEL,
      cancelButtonText: this._NO_LABEL
    }).then((result) => {
      if (result.value) {
        this.configTablaPaquetes.data.forEach((valueRes, index) => {
          if (valueRes.rowId == row.rowId) {
            this.configTablaPaquetes.data.splice(index, 1);

            this.bloqueaBoton = false;

            return false;
          }
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.bloqueaBoton = false;
      }
    });
  }

  sendNotificacion() {
    try {
      this.blockSendNotBoton = true;

      this.dataFormData = new FormData();

      if (!this.checkNotificacion()) {
        let mensaje = this._translate.instant("ERROR_FORMULARIO_NOTF_LABEL");
        notify(mensaje, DANGER_NOTIFY);

        this.blockSendNotBoton = false;
        return false;
      }

      let direccionSel = {
        pais_id: this.objDireccionEdit.ciudad.departamento.gepaise_id,
        estado_id: this.objDireccionEdit.ciudad.gedepartamento_id,
        ciudad_id: this.objDireccionEdit.ciudad.id,
        dir: this.objDireccionEdit.direccion,
        zip: this.objDireccionEdit.zip,
      };

      if (this.direccionesUserComponent.checkBoxDestinatario && this.userInfo.direcciones) {
        direccionSel = {
          pais_id: this.userInfo.direcciones[0].ciudad.departamento.gepaise_id,
          estado_id: this.userInfo.direcciones[0].ciudad.gedepartamento_id,
          ciudad_id: this.userInfo.direcciones[0].ciudad.id,
          dir: this.userInfo.direcciones[0].direccion,
          zip: this.userInfo.direcciones[0].zip,
        }
        this.dataFormData.append('desapellidos', this.userInfo.lastname);
        this.dataFormData.append('desnombres', this.userInfo.name);
        this.dataFormData.append('destelefono', this.userInfo.telefono);
      } else {
        this.dataFormData.append('desapellidos', this.objDireccionEdit.apellidos);
        this.dataFormData.append('desnombres', this.objDireccionEdit.nombres);
        this.dataFormData.append('destelefono', this.objDireccionEdit.telefono);
      }
     
      this.dataFormData.append('pqtenbdg', this.paqueteEnBodega ? 'true' : 'false');
      this.dataFormData.append('getipo_id', this._notificacionSel);
      this.dataFormData.append('getipo_recogida_id', '-1');
      this.dataFormData.append('direccionSel', JSON.stringify(direccionSel));
      // this.dataFormData.append('destinatarioCliente', this.checkBoxDestinatario ? 'true' : 'false');

      // if (this.checkBoxDestinatario) {
      //   direccionSel = this.userInfo.direcciones[0]
      //   this.dataFormData.append('direccionSel', this.userInfo.direcciones[0] 
      // }

      if (this._recogidaSel != '') {
        this.dataFormData.append('getipo_recogida_id', this._recogidaSel);
      }

      this.configTablaPaquetes.data.forEach((value, index) => {
        this.dataFormData.append("paquetes[]", JSON.stringify(value));

        if (this._notificacionSel == this.notifi_id) {
          this.dataFormData.append("adjunto[]", value.adjunto);
        }
      });

      Swal({
        title: '',
        html: '<span style="font-size: 15px">' + this.confirmaNotif + '</span><br>',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this._YES_LABEL,
        cancelButtonText: this._NO_LABEL,
        onClose: () =>
            this.blockSendNotBoton = false
      }).then((result) => {
        if (result.value) {

          const req = new HttpRequest<FormData>('POST', `${CONTROL_APP_CONST.API_URL}notificaciones`, this.dataFormData, {
            reportProgress: true
          });
          this._http.request(req)
              .subscribe(
                  (response) => {
                    this.blockSendNotBoton = false;
                    this._objetEmmit = {success: true, msg: 'SE_REGISTRO_NOTIFICIACION_LABEL'};
                  },
                  (error) => {
                    this.dataFormData = new FormData();
                    this.blockSendNotBoton = false;
                    this._objetEmmit = {success: false, msg: error};
                  }, () => {
                    this.objDireccionEdit = new DireccioneModel();
                    this.setTipoNotificacion();
                    this._authService.loadUserInfo();
                    this.onCreacion.emit(this._objetEmmit);
                  }
              );
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          this.blockSendNotBoton = false;
        }
      });
    }
    catch (err) {
      this.dataFormData = new FormData();
      this.blockSendNotBoton = false;
      this.onCreacion.emit({success: false, msg: 'INTERNAL_ERROR_CONTACT_ADMIN'});
    }
  }

  checkNotificacion() {
    this.dataErrorNotificacion.error.tipoRecogida = false;

    let x = 0;

    if (this._notificacionSel == this.pickup_id) {
      if (this._recogidaSel == '') {
        this.dataErrorNotificacion.error.tipoRecogida = true;
        x++;
      }
    }
    
    if (this.direccionesUserComponent.checkBoxDestinatario) {
      if (this.userInfo.direcciones.length <= 0) {
        x++;
        // console.log('EL USUARIO NO TIENE DIRECCIONES REGISTRADAS')
      }
    } else if (!this.direccionesUserComponent.checkDireccion()) {
      x++;
      // console.log('EL USUARIO NO HA DIGITADO UNA DIRECCION')
    }
    if (this.configTablaPaquetes.data.length <= 0) {
      let mensaje = this._translate.instant("DEBE_INGRESAR_PAQUETES_LABEL");
      notify(mensaje, WARING_NOTIFY);

      x++;
    }
    // SE VALIDA QUE EL DESTINO NO ESTE REPETIDO
    if (!this.direccionesUserComponent.desSelect){
      this.direccionesUserComponent.configTablaDirecciones.data
        .forEach(element => {
            if(element.nombres.toLowerCase() == this.objDireccionEdit.nombres.toLowerCase()){
              if(element.apellidos.toLowerCase() == this.objDireccionEdit.apellidos.toLowerCase()){
                if(element.telefono == this.objDireccionEdit.telefono){
                  if(element.zip == this.objDireccionEdit.zip){
                    if(element.direccion.toLowerCase() == this.objDireccionEdit.direccion.toLowerCase()){
                      let mensaje = this._translate.instant("SELECCIONA_NUEVO_DESTINO");
                      notify(mensaje, WARING_NOTIFY);
                      x++;
                    }
                  }
                }
              }
            }
          });
    }

    return (x == 0);
  }

  getTransportadoras() {
    this._http.get<ITransportadoras[]>(`${CONTROL_APP_CONST.API_URL}listaTransportadora`, {})
        .subscribe(
            (response) => {
              response.forEach((value) => {
                this.listaTransportadoras.push({id: value.id, nombre: value.nombre});
              });
            },
            (error) => {
              this._logger.debug(error.error);
            }
        )
  }

  getTiendas() {
    this._http.get<ITiendas[]>(`${CONTROL_APP_CONST.API_URL}listaTiendas`, {})
        .subscribe(
            (response) => {
              response.forEach((value) => {
                this.listaTiendas.push({id: value.id, nombre: value.nombre});
              });
            },
            (error) => {
              this._logger.debug(error.error);
            }
        )
  }

  getTipNotificacion() {
    this._http.get<ITipoTable[]>(`${CONTROL_APP_CONST.API_URL}tiposControlBoxex`, {
      params:
          {grupo: 'NOTIFTIPO'}
    })
        .subscribe(
            (response) => {

              response.forEach((value, key) => {
                if (value.nombre == "Notificacion") {
                  this.tiposNotificacion.push(
                      {
                        value: value.id,
                        label: 'COMPRA_INTERNET_LABEL'//'Compra por Internet',
                      }
                  );
                  this.notifi_id = value.id;
                  this.notificacionSel = value.id;
                }
                else if (value.nombre == "Pick Up") {
                  this.tiposNotificacion.push(
                      {
                        value: value.id,
                        label: 'RECOG_PAQUETE_LABEL'//'Recogida de Paquete',
                      }
                  );
                  this.pickup_id = value.id
                }
              });
            },
            (error) => {
              this._logger.debug(error.error);
            }
        )
  }

  animateAddBtn() {
    animation(SHAKE_ANIMATION, '#addPqt');
  }

  getTipRecogida() {
    this._http.get<ITipoTable[]>(`${CONTROL_APP_CONST.API_URL}tiposControlBoxex`, {
      params:
          {grupo: 'TIPO_ENTREGA_NOTIF'}
    })
        .subscribe(
            (response) => {
              response.forEach((value, key) => {

                this.tiposRecogida.push(
                    {
                      value: value.id,
                      label: value.nombre//'Compra por Internet',
                    }
                );
              });
            },
            (error) => {
              this._logger.debug(error.error);
            }
        )
  }

  setTipoNotificacion() {

    this._recogidaSel = '';

    this.paqueteEnBodega = false;

    this.dataErrorPaquetes.error.tracking = false;
    this.dataErrorPaquetes.error.valordeclarado = false;
    this.dataErrorPaquetes.error.peso = false;
    this.dataErrorPaquetes.error.altopqt = false;
    this.dataErrorPaquetes.error.anchopqt = false;
    this.dataErrorPaquetes.error.largopqt = false;
    this.dataErrorPaquetes.error.paqdesc = false;
    this.dataErrorPaquetes.error.url = false;
    this.dataErrorPaquetes.error.cantidad = false;

    this.configTablaPaquetes.data.splice(0, this.configTablaPaquetes.data.length);

    this.setPaquete();

    if (this._notificacionSel == this.notifi_id) {
      this.configTablaPaquetes.columns = [
        {
          label: 'TIENDA_LABEL', name: 'webtienda_id', options: {
          render: (data, index, row) => {
            return row.tienda.nombre;
          }
        }
        },
        {label: 'TRACKING_LABEL', name: 'tracking'},
        {label: 'VALOR_DECLARADO_LABEL', name: 'valordeclarado'},
        {label: 'VALOR_ASEGURADO_LABEL', name: 'valorasegurado'},
        {label: 'CONTENIDO_PAQUETE', name: 'paqdesc'}
      ];
    }

    else if (this._notificacionSel == this.pickup_id) {
      this.configTablaPaquetes.columns = [
        {label: 'VALOR_DECLARADO_LABEL', name: 'valordeclarado'},
        {label: 'VALOR_ASEGURADO_LABEL', name: 'valorasegurado'},
        {label: 'PESO_LBS_LABEL', name: 'peso'},
        {label: 'ALTO_PULG_LABEL', name: 'altopqt'},
        {label: 'ANCHO_PULG_LABEL', name: 'anchopqt'},
        {label: 'LARGO_PULG_LABEL', name: 'largopqt'},
        {label: 'CONTENIDO_PAQUETE', name: 'paqdesc'}
      ];
    }

    else if (this._notificacionSel == this.compraWebBox) {
      this.configTablaPaquetes.columns = [
        {label: 'URL_LABEL', name: 'valordeclarado'},
        {label: 'CANTIDAD_LABEL', name: 'valorasegurado'},
        {label: 'CONTENIDO_PAQUETE', name: 'paqdesc'}
      ];
    }
  }

  setNewValorAsegurado() {
    if (this.newPaquete.valordeclarado > 0) {
      if (this.newPaquete.valordeclarado <= this.minVlrAsegurado) {
        this.newPaquete.valorasegurado = this.minVlrAsegurado;
      } else if (this.newPaquete.valordeclarado > this.limitVlrAsegurado) {
        this.newPaquete.valorasegurado = this.limitVlrAsegurado;
      } else {
        this.newPaquete.valorasegurado = this.newPaquete.valordeclarado;
      }
    } else {
      this.newPaquete.valorasegurado = 0;
    }
  }

  checkUps(medidaMay, medidaMen_1, medidaMen_2) {

    let volumenUPS = Number(medidaMay) + (( Number(medidaMen_1) + Number(medidaMen_2)) * 2);

    return volumenUPS > 165;
  }


  ngOnDestroy() {
    this._subGeparameters$.unsubscribe();
  }
}
    


// WEBPACK FOOTER //
// ./src/app/control-app/shared/crear-notificacion/crear-notificacion.component.ts